<template>
  <div class="Rank">
    <div class="note" v-if="procedure == 1">
      <p>每日12点与20点更新积分和排行榜，如有疑问请联系微信客服</p>
      <p class="course"><a href="https://vvf.h5.xeknow.com/s/3GlJMZ" target="_blank">选拔赛初赛和复赛官方指导</a><my_image :src="courseQR" class="courseQR" :width="'10em'" /> </p>
      <!-- <p>你的战绩这么厉害，快扫描二维码生成炫酷海报，刷爆朋友圈吧
           <a href="#" @click="jump(0)">点击查看详细指引</a>
           </p> -->
      <!-- <p>&#128293 分享战绩海报来领红包啦！
           <a href="#" @click="jump(1)">点击查看活动详情</a>
           </p> -->
      <!-- <my_image :src="qrcode" :width="'10em'" /> -->

    </div>
    <div class="note" v-if="procedure == 2">
      <p>初赛结束，排行榜积分停止更新。如有疑问请联系微信客服</p>
      <!-- <p>如果需要进一步学习准备决赛，请点击<a href="https://appKGNJyWGE8466.h5.xiaoeknow.com/content_page/eyJ0eXBlIjoiMyIsInJlc291cmNlX3R5cGUiOjI1LCJyZXNvdXJjZV9pZCI6IiIsImFwcF9pZCI6ImFwcEtHTkp5V0dFODQ2NiIsInByb2R1Y3RfaWQiOiJ0ZXJtXzVmYTUyNzA1MmJlMWFfSXhBVTdKIn0" target="_blank">训练营链接</a>了解更多信息。</p> -->
    </div>
    <div class="group">
      <div class="grp fs20" :class="{focus: fcg==g.key }" v-for="g in groups" @click="focus(g.key)">{{g.text}}{{g.extra}}</div>
      <!-- <div class="grp fs20" :class="{focus: fcg=='n'}" @click="focus('n')">宁夏赛区</div>
           <div class="grp fs20" :class="{focus: fcg=='sz'}" @click="focus('sz')">苏州赛区</div> -->
    </div>
    <my_table :infos="extraInfo" :titles="extraTitles" v-if="showExtraArea && fcg == 'n'"></my_table>
    <my_table :infos="extraInfo" :titles="extraTitles" v-if="showExtraArea && fcg == 'sz'"></my_table>
    <my_table :infos="info" :titles="titles" :isRank="true" :rankLength="-1" v-else></my_table>
  </div>
</template>

<script>
 import MyTable from '@/components/Table.vue'
 import QRCode from '@/assets/image/rank/aiyouth-qr.png'
 import CourseQR from '@/assets/image/rank/course-qr.png'
 import MyImage from '@/components/Image.vue'

 export default {
   name: 'Rank',
   props: ['procedure', 'leaderboard'],
   computed: {
     showExtraArea() {
       return this.fcg =='n' || this.fcg == 'sz';
     },
     user() {
       return this.$store.state.auth.user
     },
     groups() {
       return this.$store.state.enroll.groups
     },
     titles() {
       return this.$store.state.score.rank.title
     },
     game_slug() {
       return this.$store.state.game_slug
     },
     extraTitles() {
       return ['排名', '', '逃出地牢积分', '省市']
     }, 
     infos () {
       return this.$store.state.score.rank.infos
     },
     indexOfExtra() {
       return {
         'n':'NingXia',
         'sz': "SuZhou"
       }
     },
     remapExtra() {
       return {
         'NingXia': '宁夏',
         'SuZhou': '苏州'
       }
     },
     indexOfGroup() {
       return {
         's': 1,
         'm': 2,
         'l': 3
       }
     },
     qrcode() {
       return QRCode
     },
     courseQR() {
       return CourseQR
}
   },
   data() {
     return {
       fcg: 's',
       info: [],
       extraInfo: [],
     }
   },
   methods: {
     fetchData () {
       if(this.showExtraArea)
       {
         let round = this.game_slug.slice(0, -1) + '1';
         let area =  this.indexOfExtra[this.fcg];
         let uri = '/api/extra_rank?round='+round+'&area='+area;
         this.$http.get(uri)
             .then(res => {
               this.extraInfo = res.data.data.map(d=>
                 {return [d.rank, d.username, d.score, this.remapExtra[d.area]]})
             })
       }
       else {
         let round = this.game_slug.slice(0, -1) + '1';
         let group =  this.indexOfGroup[this.fcg];
         let uri = '/api/rank?round='+round+'&group='+group;
         if(this.leaderboard =='province') {
           uri = uri.replace('rank', 'area_rank');
           uri += '&area_id=' + this.user.area_id;
         }
         this.$http.get(uri)
             .then(res => {
               this.info = res.data.map(d=>
                 {return [d.rank, d.username, d.ozaria , d.area_name]})
             })
       }
     },
     focus(k) {
       this.fcg = k
       this.fetchData()
     },
     jump(i) {
       if(i == 0)
         window.open('https://mp.weixin.qq.com/s/SzVnoGDSahvE1dF95vfqkg', '_blank');
       else
         window.open('https://mp.weixin.qq.com/s/wF4I_PQmJZmhVroE8VaK9Q', '_blank')
     }
   },
   mounted() {
     this.fetchData()
   },
    watch: {
      leaderboard () {
        this.fetchData()
      }
    },
   components: {
     my_table: MyTable,
     my_image: MyImage
   }
 }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .Rank{
   display: flex;
   justify-content: center;
   align-items: center;
   flex-direction: column;
   margin-top: 5vw;
   margin-bottom: 3.4vw;
 }
 .group{
   display: flex;
   align-items:center;
   justify-content: space-around;
   width: 50vw;
   border-bottom: 1px dashed black;
   margin-bottom: 1.5625vw;
 }
 .grp{
   line-height: 2.5vw;
 }
 .focus{
   border-bottom: 1px solid black;
   color: #4411FF;
 }
 .note{
   text-align: center;
   margin-bottom: 3vw;
   color: black;
 }
  .courseQR{
    display: none;
    position: absolute;
    top: 2em;
}

  .course {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
}
  .course:hover>.courseQR {
    display: block;
}
</style>
